export default __webpack_public_path__ + "static/media/favorite-alt.a143a8f7.svg";